import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import VehicleTypeModel from "../../models/masters/vehicletype-model";
import axios, { AxiosError } from "axios";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/VehicleType/GetAllVehicleType";// //{/api/Category/GetAllCategory}`)  //// "https://localhost:7054/api/Category/GetAllCategory";
export const useGetVehicleTypes = createQuery<
  VehicleTypeModel[],
  null,
  AxiosError
>({
  queryKey: ["keyVehicleTypelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});